import React, { useState, useEffect } from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  IconButton,
  Button,
  TableContainer,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@material-ui/core';

import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { useStyles, StyledTableCell } from '../../adminStyles';
import moment from 'moment';
import { DB_DATE_FORMAT, DISPLAY_DATE_FORMAT } from '../../../../redux/constants';

const ProjectsTable = props => {
  const [del, setDel] = useState({ open: false, id: 0 });
  const [projectName, setProjectName] = useState('');
  const {
    sortLabel,
    tableRoot,
    tableContainer,
    customHeaderCont,
    tableHeaders,
    dialogTitle,
  } = useStyles();

  const { columns, rows, sortArray, orderAscending, orderBy, asc, searchTerm } = props;
  
  const handleClose = () => setDel({ open: false, id: 0 });
  const handleDeleteConfirm = () => {
    props.deleteProject(del.id)
    setDel({ open: false, id: 0 })
  };

  const getProjectName = () => {
    let _project = rows.filter(project => project.projectId === del.id);
    _project.length && setProjectName(_project[0].projectName);
    return;
  };

  useEffect(() => {
    getProjectName(del.id);
  }, [del]);

  const renderStyledTableCell = () => {
    console.log('ROWS', rows);
    return columns.map(column =>
      column.id === 'projectName' ||
      column.id === 'start' ||
      column.id === 'end' ||
      column.id === 'client' ? (
        <StyledTableCell
          key={column.id}
          align='center'
          padding={column.disablePadding ? 'none' : 'default'}
          sortDirection={orderBy === column.id ? orderAscending : false}
        >
          <TableSortLabel
            active={orderBy === column.id}
            direction={asc}
            onClick={() => sortArray(rows, column.id)}
            className={sortLabel}
          >
            {column.label}
          </TableSortLabel>
        </StyledTableCell>
      ) : (
        <StyledTableCell
          key={column.id}
          align='center'
          padding={column.disablePadding ? 'none' : 'default'}
        >
          {column.label}
        </StyledTableCell>
      )
    );
  };

  const renderTableBody = () =>
    rows
      .filter(
        row =>
          (row.projectName || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
          (row.client || '').toLowerCase().includes(searchTerm.toLowerCase())
      )
      .map((row, i) => {
        return (
          <TableRow tabIndex={-1} key={rows.code} size='small'>
            {columns.map(column => {
              const value = row[column.id];
              return (
                <TableCell key={column.id} align='center' width={column.mainWidth}>
                  {column.id === 'projectName' ? value : null}
                  {column.id === 'startDate'
                    ? value
                      ? moment(value, DB_DATE_FORMAT).format(DISPLAY_DATE_FORMAT)
                      : null
                    : null}
                  {column.id === 'endDate'
                    ? value
                      ? moment(value, DB_DATE_FORMAT).format(DISPLAY_DATE_FORMAT)
                      : null
                    : null}
                  {column.id === 'client' ? value : null}
                  {column.id === 'action' ? (
                    <>
                      <IconButton
                        color='primary'
                        onClick={() => {
                          props.onEditClick(row);
                          props.history.push(`/admin/projectdetails/${row.projectId}`);
                        }}
                      >
                        <EditIcon />
                      </IconButton>
                      <IconButton
                        color='primary'
                        onClick={() => {
                          setDel({
                            open: true,
                            id: row.projectId,
                          });
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </>
                  ) : null}
                </TableCell>
              );
            })}
          </TableRow>
        );
      });

  const renderTableHeader = () => {
    return (
      <div className={customHeaderCont}>
        <div align='center' className={tableHeaders}>
          Projects Total:
          <span style={{ color: '#42ADE2' }}>
            {
              rows.filter(row =>
                (row.projectName || '').toLowerCase().includes(searchTerm.toLowerCase())
              ).length
            }
          </span>
        </div>
      </div>
    );
  };
  return (
    <Paper className={tableRoot}>
      <TableContainer className={tableContainer}>
        <TableRow>{renderTableHeader()}</TableRow>
        <Table stickyHeader>
          <TableHead>
            <TableRow>{renderStyledTableCell()}</TableRow>
          </TableHead>
          <TableBody>{renderTableBody()}</TableBody>
        </Table>
      </TableContainer>

      <Dialog
        open={del.open}
        onClose={handleClose}
        aria-labelledby='draggable-dialog-title'
      >
        <DialogTitle id='draggable-dialog-title'>
          <Typography variant='h5' className={dialogTitle}>
            Delete Project Confirmation
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>{`Are you sure you want to delete ${projectName} ?`}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} color='primary'>
            Cancel
          </Button>
          <Button onClick={handleDeleteConfirm} color='primary'>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
};

export default ProjectsTable;
